module.exports = __webpack_public_path__ + "img/connect-bg.c7be67d8.svg";